<template>
  <div class="columns is-multiline">
    <div v-for="(pat_layer, plindex) in pattern.layers" :key="`PATTERN_LAYER_${plindex}`" class="column is-12">
      <div v-for="(column,col_index) in pat_layer.columns" :key="`PROW_${plindex}_COL_${col_index}`" :style="`position: relative;border: 1px solid #000;float:left;display:flex;align-items:center;justify-content:center;width:${column.width}px;height:${column.width}px;${column.type == 'USERINP' ? 'background:#5252ff;' : ''}`" :class="`m-1 ${isCurrenPatternBoxSelected(plindex, col_index, column.type) ? 'pattern-input-selected' : ''}`" @click="selectCurrenPatternBox(plindex, col_index, column.type)">
        <show-image style="height:100%;width:100%" v-if="(column.type == 'DISPLAY') && (column.clipart != -1)" :src="pattern.cliparts[column.clipart].file" />
        <show-image v-if="isPatternBoxFilled(plindex, col_index, column.type)" style="height:80%;width:80%;" :src="patternBoxUserImg(plindex, col_index, column.type)" />
      </div>
    </div>
    <div class="column is-12 is-flex">
      <!--Buttons-->
      <focus-button v-for="(pattern_clipart, pattern_clipart_index) in pattern.cliparts" :key="`PATTERN_QUESTION_OPTION_${pattern_clipart_index}`" :img="pattern_clipart.file" @clicked="patternButtonClicked(pattern_clipart_index, $event)" :clicked_state="false" :is_clicked="false"></focus-button>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex"
import FocusButton from '@/components/FocusButton'
import ShowImage from '@/components/General/ShowImage'
export default {
  name: "show-pattern",
  components: {
    ShowImage,
    FocusButton
  },
  props: {
    pattern : {
      type : Object,
      required : true
    },
  },
  data() {
    return {
      pattern_track : {
        current_button : null,
        current : {
          layer_index : null,
          col_index : null
        },
        layers : {}
      },
    };
  },
  computed: {
    ...mapGetters(["fetchCurrentAnswer"]),
  },
  methods: {
    ...mapActions(["updateCurrentAnswer"]),
    isCurrenPatternBoxSelected(layer_index, col_index, type){
      // Checks whether a pattern column box of type USERINP is currently selected
      return ((type == 'USERINP') && (this.pattern_track.current.layer_index == layer_index) && (this.pattern_track.current.col_index == col_index))
    },
    selectCurrenPatternBox(layer_index, col_index, type){
      if(type == 'USERINP'){
        this.$set(this.pattern_track.current, 'layer_index', layer_index)
        this.$set(this.pattern_track.current, 'col_index', col_index)
      }
    },
    patternBoxUserImg(layer_index, col_index, type){
      // Returns the corresponding clipart image of the pattern column box filled
      if(this.isPatternBoxFilled(layer_index, col_index, type)){
        return this.pattern.cliparts[this.pattern_track.layers[layer_index][col_index]].file
      }
      return ''
    },
    isPatternBoxFilled(layer_index, col_index, type){
      // Checks whether a pattern column box of type USERINP is currently filled and has a response
      let bool = false
      if((type == 'USERINP') && (this.pattern_track.layers[layer_index]) && (this.pattern_track.layers[layer_index][col_index] !== undefined)){
        bool = true
      }
      return bool
    },
    patternButtonClicked(button_index, clicked_state){
      if(clicked_state){
        //Setting current button
        this.pattern_track.current_button = button_index
        const layer_index = this.pattern_track.current.layer_index
        const col_index = this.pattern_track.current.col_index
        if(!this.pattern_track.layers[layer_index]){
          this.pattern_track.layers[layer_index] = {}
        }
        this.pattern_track.layers[layer_index][col_index] = button_index
        this.pattern_track = JSON.parse(JSON.stringify(this.pattern_track))
        this.emitData()
      }
    },
    emitData(){
      this.updateCurrentAnswer({
        key : "pattern",
        value : this.pattern_track
      })
    }
  },
  watch : {
    pattern_track : function(){
      // Updating the current selected box
      let current_found = false
      //Finding the first occurance of box
      for(let pattern_layer_index in this.pattern.layers){
        const layer = this.pattern.layers[pattern_layer_index]
        for(let column_index in layer.columns){
          const column = layer.columns[column_index]
          if(column.type == 'USERINP'){
            //If the box is not filled, update this location in current
            if((!this.isPatternBoxFilled(pattern_layer_index, column_index, column.type))){
              current_found = true
              const new_obj = {
                layer_index : pattern_layer_index,
                col_index : column_index
              }
              this.$set(this.pattern_track, 'current', new_obj)
              break
            }
          }
        }

        if(current_found){
          break
        }
      }
    },
    fetchCurrentAnswer : {
      handler : function(new_value){
        if(new_value.pattern){
          this.pattern_track = new_value.pattern
        }
      },
      deep : true
    }
  },
  created(){
    if(this.fetchCurrentAnswer){
      this.pattern_track = this.fetchCurrentAnswer.pattern
    }
    
    if(!this.pattern_track.current){
      this.pattern_track.current = {}
    }
  },
};
</script>
<style>
.pattern-input-selected{
  border: 5px solid #ff8b46!important;
}
</style>